export default {
  /**
   * Indicates whether we're currently navigating to another route
   * @returns {Boolean}
   */
  isNavigating: (state) =>
    state.navigating.from != null &&
    state.navigating.to != null &&
    state.navigating.startedAt != null &&
    state.navigating.finishedAt == null,

  /**
   * Indicates whether we're done navigating to another route
   * @returns {Boolean}
   */
  hasNavigated: (state) =>
    state.navigating.from != null &&
    state.navigating.to != null &&
    state.navigating.startedAt != null &&
    state.navigating.finishedAt != null,

  /**
   * Returns route with the specified name or path
   * @param {String} nameOrPath Route name or path
   * @returns {Route}
   */
  getRoute: (state) =>
    nameOrPath =>
      state.routes.find(route => route.name === nameOrPath || route.path === nameOrPath),

  /**
   * Returns true if route requires a session
   * @param {String} nameOrPath Route name or path
   * @type {Boolean}
   */
  isSecureRoute: () =>
    nameOrPath =>
      this.getRoute(nameOrPath)?.meta.isSecure,

  /**
   * Returns permissions required by the route
   * @param {String} nameOrPath Route name or path
   * @type {Array[String]}
   */
  getRoutePermissions: () =>
    nameOrPath =>
      this.getRoute(nameOrPath)?.meta.permissions || [],
}
